var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"white pa-2 elevation-2"},[_c('img',{attrs:{"alt":"Symbolforklaring for kart","height":"150px","src":require("../../../assets/img/mapLegend.svg")}})])
}]

export { render, staticRenderFns }